import React from 'react';
import { __ } from '../../../../utils/translation-service';

export class FooterLink extends React.Component<any> {
    public render() {
        return (
            <a
                key={this.props.key}
                href={this.props.targetUrl}
                title={this.props.linkTitle}
                rel={this.props.linkTitle}
                style={{ fontFamily: 'Arial,Helvetica,sans-serif' }}
            >
                {this.props.title}
            </a>
        );
    }
}
